import type { SavedView2D } from './views2dTypes'

// Lista de vistas do modo 2D em MOBILE. No telemóvel não há espaço para
// o navegador de vistas com os três criadores: a escolha reduz-se a uma
// lista única de "o que já existe" (vistas gravadas) mais "plantas por
// piso", que é o que se quer ver em obra. Módulo puro para ter teste.

export interface MobileViewOption {
  /** Chave estável para o `value` do `<select>`. */
  key: string
  label: string
  kind: 'saved' | 'storey'
  /** Só em `saved`: id da vista gravada. */
  savedId?: string
  /** Só em `storey`: índice na lista de pisos recebida. */
  storeyIndex?: number
}

export interface StoreyOption {
  name: string
  elevation: number
}

function fmt(v: number): string {
  return Number.isFinite(v) ? v.toFixed(2) : '-'
}

/** Vistas gravadas primeiro (é o trabalho já feito, e no telemóvel é o
 *  caso de uso principal), plantas por piso a seguir. Nomes vazios ou só
 *  com espaços recebem um rótulo de recurso para a linha não sair em
 *  branco. */
export function mobileViewOptions(
  saved: SavedView2D[],
  storeys: StoreyOption[],
): MobileViewOption[] {
  const out: MobileViewOption[] = []
  for (const v of saved) {
    out.push({
      key: `saved:${v.id}`,
      label: `${v.def.kind === 'plan' ? 'Planta' : 'Corte'} · ${
        v.name.trim() || 'sem nome'
      }`,
      kind: 'saved',
      savedId: v.id,
    })
  }
  storeys.forEach((s, i) => {
    out.push({
      key: `storey:${i}`,
      label: `Piso · ${s.name.trim() || 'sem nome'} (${fmt(s.elevation)} m)`,
      kind: 'storey',
      storeyIndex: i,
    })
  })
  return out
}
